import { HttpClient } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { cloneDeep } from 'lodash';
import { firstValueFrom } from 'rxjs';
import {
  ConfirmEventType,
  ConfirmationService,
  MenuItem,
  MessageService,
  TreeDragDropService,
} from 'primeng/api';
import { Menu } from 'primeng/menu';
import { OverlayPanel } from 'primeng/overlaypanel';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { CheckBoxQuestion } from 'src/app/misc/component/dynamic-form/question-checkbox';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { TextEditorQuestion } from 'src/app/misc/component/dynamic-form/question-editor';
import { ImageUploadQuestion } from 'src/app/misc/component/dynamic-form/question-imageupload';
import { TextAreaQuestion } from 'src/app/misc/component/dynamic-form/question-textarea';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import { TreeSelectQuestion } from 'src/app/misc/component/dynamic-form/question-treeselect';
import { RowFileSelectQuestion } from 'src/app/misc/component/dynamic-form/row-file-select-question';
import { DataService } from 'src/app/services/data.service';
import { ExportService } from 'src/app/services/export.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { SerializeService } from 'src/app/services/serialize.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
@Component({
  selector: 'app-admin',
  templateUrl: './klibrary_admin.component.html',
  styleUrls: ['./klibrary_admin.component.scss'],
  providers: [ConfirmationService],
})
export class KLibraryAdminComponent {
  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;
  preloader = true;
  //Search fields
  searchterm = '';
  category: any;
  fromDate: any;
  toDate: any;
  selectedOU: any;
  showFilters = false;

  get hasActiveFilters(): boolean {
    return !!(this.category || this.selectedOU || this.fromDate || this.toDate);
  }

  translator: TranslatorPipe = new TranslatorPipe()
  //OUS to set parent to null
  parentOUS = [
    'الوزارات',
    'الجهات المشاركة',
    'كيانات أخرى',
    'وحدة التنظيم',
  ];

  //Data to show in table
  data: any[] = [];
  filteredData: any[] = [];

  //Raw API data
  libraryData: any = [];

  //Dropdown values
  ous: any[] = [];
  categoryData: any = [];

  //Image or icon URL
  staticURL = GlobalConstants.staticFilesURL;

  //Conditional checks
  openModal: boolean = false;
  updateData: any;

  //Create Update form questions
  questions: any[] = [];
  updateQuestion: any = [];

  //Error messages
  messages: any = [];
  formMessages: any = [];

  //File upload links
  fileLinks: any = [];
  ousWithCreatePermission: any[] = [];

  availableOus: any[] = [];
  availableCategories: any[] = [];

  @ViewChild('rowMenu') rowMenu!: Menu;
  activeRowMenu: MenuItem[] = [];
  @ViewChild('filesPanel') filesPanel!: OverlayPanel;
  activeFiles: any[] = [];

  // Download progress, per row (files done / total) and per single file
  rowDownloads = new Map<string, { done: number; total: number }>();
  fileDownloads = new Set<any>();
  activeFilesTitle = '';

  //Table view state
  currentPage = 1;
  pageSize = 10;
  pageSizeOptions = [5, 10, 25, 50];
  private libraryById = new Map<string, any>();

  constructor(
    public dataService: DataService,
    private ouService: OrgUnitsService,
    public permissionService: PermissionHandlerService,
    private serializeService: SerializeService,
    private confirmationService: ConfirmationService,
    private exportService: ExportService,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    Promise.all([this.fetchOUS(), this.getCategories()]).then((e) => {
      this.getOUSWithCreatePermission().then(() => {
        this.getData().then((f) => {
          this.makeQuestions();
          this.preloader = false;
        });
      })
    });
  }

  async getOUSWithCreatePermission() {
    this.ousWithCreatePermission = await this.permissionService.extractOUChildrenFromData('KNOWLEDGE_LIBRARY', 'c', this.ous);
  }

  hasPermission(flag: string) {
    return this.permissionService.hasPermission('KNOWLEDGE_LIBRARY', flag);
  }

  openCreateModal() {
    this.updateData = null;
    this.updateQuestion = [];
    this.openModal = true;
  }

  handleFilter(filterName: string, value: any) {
    if (filterName == 'DATE_FROM_FILTER') {
      this.fromDate = value;
    } else if (filterName == 'DATE_TO_FILTER') {
      this.toDate = value;
    }
    this.data = [];
    this.currentPage = 1;
    if (filterName == 'OU_FILTER') {
      this.filteredData = this.libraryData.filter((e: any) => {
        if (!value.hasOwnProperty('_id') && e.ou == null) {
          return true;
        } else if (e.ou != null && value._id == e.ou._id) {
          return true;
        }
        return false;
      });
    } else if (
      filterName == 'DATE_FROM_FILTER' ||
      filterName == 'DATE_TO_FILTER'
    ) {
      this.filteredData = this.libraryData.filter((e: any) => {
        const createdAt = new Date(e.createdAt);
        let date = new Date(
          createdAt.getFullYear(),
          createdAt.getMonth(),
          createdAt.getDate()
        );
        if (this.fromDate != null && this.toDate == null) {
          if (date.getTime() >= this.fromDate.getTime()) {
            return true;
          } else {
            return false;
          }
        } else if (this.fromDate == null && this.toDate != null) {
          if (date.getTime() <= this.toDate.getTime()) {
            return true;
          } else {
            return false;
          }
        } else {
          if (
            date.getTime() >= this.fromDate.getTime() &&
            date.getTime() <= this.toDate.getTime()
          ) {
            return true;
          } else {
            return false;
          }
        }
      });
    } else if (filterName == 'CATEGORY_FILTER') {
      this.filteredData = this.libraryData.filter((e: any) => {
        return e.categoryname == value.label;
      });
    }
    this.mapToTableData(this.data, this.filteredData);
  }

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  actionCall($event: any) {
    switch ($event.action) {
      case 'Delete':
        this.confirm({
          message: this.translate('Are you sure you want to do this?'),
          header: this.translate('Confirmation message'),
          icon: 'pi pi-exclamation-triangle',
          action: () => this.deleteKLibrary($event.id),
        });
        break;
      case 'Update':
        this.updateData = this.libraryData.find(
          (item: any) => item._id == $event.id
        );

        if (this.updateData) {
          this.fileLinks = this.updateData.link;
        }
        this.updateQuestion = [
          new TextboxQuestion({
            key: 'name',
            label: 'العنوان',
            required: true,
            order: 1,
            icon: 'pi pi-file',
            className: 'col-12',
            value: this.updateData?.name,
          }),
          new TextEditorQuestion({
            key: 'description',
            label: 'ادخل الوصف',
            required: true,
            order: 2,
            className: 'col-12',
            value: this.updateData?.description,
          }),
          new DropdownQuestion({
            key: 'category',
            label: 'حدد تصنيف',
            filter: true,
            required: true,
            options: this.categoryData,
            order: 3,
            // Match on name + icon, then name alone; a renamed or re-iconed
            // category must not stop the edit dialog from opening
            value: (
              this.categoryData.find(
                (e: any) =>
                  this.updateData.categoryname == e.label &&
                  this.updateData.categoryicon == e.icon
              ) || this.categoryData.find((e: any) => this.updateData.categoryname == e.label)
            )?.value,
            className: 'col-md-6 col-12',
          }),
          new TreeSelectQuestion({
            key: 'ou',
            label: 'الوحدة التنظيمية',
            required: true,
            treeOptions: this.ous,
            order: 4,
            className: 'col-md-6 col-12',
            filter: true,
            value: {
              label:
                this.updateData?.ou != null
                  ? this.updateData?.ou.name
                  : 'الجهات المشاركة',
              _id: this.updateData?.ou != null ? this.updateData?.ou._id : '',
            },
          }),
          new RowFileSelectQuestion({
            key: 'file',
            label: 'تم إضافة الملف',
            order: 5,
            icon: 'pi pi-file',
            className: 'col-12',
            filetype: 'KNOWLEDGE_LIBRARY',
            fileLinks: this.updateData ? this.fileLinks : [],
          }),
          new ImageUploadQuestion({
            key: 'image',
            label: 'حدد صورة',
            isImage: true,
            order: 6,
            icon: 'pi pi-file',
            className: 'col-12',
            value: this.updateData?.image,
          }),
        ];
        this.openModal = true;
        break;
      default:
        break;
    }
  }

  downloadData() {
    let data = cloneDeep(this.data);
    data = data.map(e => {
      let links = this.libraryData.find((l: any) => l._id == e['#'].n).link
      if (links) {
        let linksStr = links.map((link: any) => {
          return GlobalConstants.staticFilesURL + link.link;
        }).join('\n')
        e['وصلة'] = { n: linksStr };
      }
      return e;
    })
    this.exportService.exportExcel(data);
  }

  async deleteKLibrary(id: string) {
    try {
      this.preloader = true;
      const res = await this.dataService.deleteData('knowledge-library/' + id);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: this.translate('File deleted successfully') },
      ];
      this.getData().then(() => {
        this.preloader = false;
      })
    } catch (error) {
    }
  }

  handleCreateUpdate(event: any) {
    if (this.fileLinks.length == 0) {
      this.formMessages = [
        { severity: 'error', summary: this.translate('error'), detail: 'Please select a file' },
      ];
      return;
    }

    let category = this.categoryData.find(
      (e: any) => e.value == event.category
    );
    if (category) {
      event['categoryname'] = category.label;
      event['categoryicon'] = category.icon;
      delete event['category'];
    }
    delete event['file'];
    event['link'] = this.fileLinks;

    this.addOrUpdateKLibrary(event);
  }

  async addOrUpdateKLibrary(data: any) {
    try {
      this.preloader = true;
      let method = 'POST';
      if (this.updateData) {
        data['_id'] = this.updateData._id;
        method = 'PUT';
      }

      if (this.parentOUS.includes(data.ou.label)) {
        data.ou = null;
      }

      let strData = this.serializeService.serialize(data);
      const res = await this.dataService.postData('knowledge-library', strData, method);
      if (res.error) {
        this.formMessages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.DynamicFormComponent.resetForm();
      this.updateData = null;
      this.openModal = false;
      this.fileLinks = [];
      this.makeQuestions();
      this.getData().then(() => {
        this.preloader = false;
      })
    } catch (error) {
      console.log(error);
    }
  }

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  async fetchOUS() {
    this.ous = await this.permissionService.extractOUChildren('KNOWLEDGE_LIBRARY', 'r');
    console.log('OUS', this.ous);
  }

  reset() {
    this.searchterm = '';
    this.category = null;
    this.selectedOU = null;
    this.fromDate = null;
    this.toDate = null;
    this.currentPage = 1;
    this.data = [];
    this.mapToTableData(this.data, this.libraryData);
  }

  makeQuestions() {
    if (this.updateData) {
      this.fileLinks = this.updateData.link;
    }
    this.questions = [
      new TextboxQuestion({
        key: 'name',
        label: this.translate('Name'),
        required: true,
        order: 1,
        icon: 'pi pi-file',
        className: 'col-12',
        value: this.updateData ? this.updateData.name : null,
      }),
      new TextEditorQuestion({
        key: 'description',
        label: this.translate('KL Description'),
        required: true,
        order: 2,
        className: 'col-12',
        value: this.updateData ? this.updateData.description : null,
      }),
      new DropdownQuestion({
        key: 'category',
        label: this.translate('KL category'),
        filter: true,
        required: true,
        options: this.categoryData,
        order: 3,
        value: this.updateData ? { label: this.updateData.categoryname } : null,
        className: 'col-md-6 col-12',
      }),
      new TreeSelectQuestion({
        key: 'ou',
        label: this.translate('KL OU'),
        required: true,
        treeOptions: this.ousWithCreatePermission,
        order: 4,
        className: 'col-md-6 col-12',
        filter: true,
        value: this.updateData
          ? this.ous.find((e: any) => this.updateData.ou == e._id)
          : null,
      }),
      new RowFileSelectQuestion({
        key: 'file',
        label: this.translate('KL File'),
        order: 5,
        icon: 'pi pi-file',
        className: 'col-12',
        filetype: 'KNOWLEDGE_LIBRARY',
        fileLinks: this.updateData ? this.fileLinks : [],
      }),
      new ImageUploadQuestion({
        key: 'image',
        label: this.translate('KL Image'),
        required: false,
        isImage: true,
        order: 6,
        icon: 'pi pi-file',
        className: 'col-12',
        value: this.updateData ? this.updateData.image : "/public/knowledge_library/klibrary.png",
      }),
      

      new CheckBoxQuestion({
        key: 'announceNotification',
        label: this.translate('Send Notification'),
        value: true,
        order: 7,
        className: 'col-12'
      })
    ];
  }

  handleDeleteLink(event: any) {
    this.fileLinks = this.fileLinks.filter((e: any) => {
      return e.name != event.name && e.link != event.link;
    });
    if (this.updateData) {
      this.updateUpdateQuestionLinks();
    } else {
      this.updateQuestionLinks();
    }
  }

  updateQuestionLinks() {
    this.questions.forEach((e: QuestionBase<any>) => {
      if (e.key == 'file') {
        e.fileLinks = this.fileLinks;
      }
    });
  }

  updateUpdateQuestionLinks() {
    this.updateQuestion = this.updateQuestion.map((e: QuestionBase<any>) => {
      if (e.key == 'file') {
        e.fileLinks = this.fileLinks;
      }
      return e;
    });
  }

  handleFileUplodMessage(event: any) {
    if (event.error) {
      this.formMessages = [
        { severity: 'error', summary: this.translate('error'), detail: event.message },
      ];
    } else {
      this.fileLinks.push({ link: event.link, name: event.name });
      this.formMessages = [
        { severity: 'success', summary: this.translate('success'), detail: event.message },
      ];
    }
    if (this.updateData) {
      this.updateUpdateQuestionLinks();
    } else {
      this.updateQuestionLinks();
    }
  }

  onSearch() {
    this.currentPage = 1;
  }

  exportExcel() {
    this.exportService.exportExcel(this.data);
  }

  // Rows matching the search box, across every text column
  get searchedData(): any[] {
    const term = this.searchterm.trim().toLowerCase();
    if (!term) return this.data;
    const contains = (value: any): boolean => {
      if (typeof value === 'string') return value.toLowerCase().includes(term);
      if (value && typeof value === 'object') return Object.values(value).some(contains);
      return false;
    };
    return this.data.filter((row: any) =>
      Object.keys(row).some((key) => key != '#' && key != 'Action' && contains(row[key]))
    );
  }

  get totalPages(): number {
    return Math.max(1, Math.ceil(this.searchedData.length / this.pageSize));
  }

  get pagedData(): any[] {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.searchedData.slice(start, start + this.pageSize);
  }

  get pageStart(): number {
    return this.searchedData.length == 0 ? 0 : (this.currentPage - 1) * this.pageSize + 1;
  }

  get pageEnd(): number {
    return Math.min(this.currentPage * this.pageSize, this.searchedData.length);
  }

  // Page numbers to show, with -1 marking a gap
  get pageNumbers(): number[] {
    const total = this.totalPages;
    const current = this.currentPage;
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
    const pages = [1];
    if (current > 3) pages.push(-1);
    for (let p = Math.max(2, current - 1); p <= Math.min(total - 1, current + 1); p++) pages.push(p);
    if (current < total - 2) pages.push(-1);
    pages.push(total);
    return pages;
  }

  goToPage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
  }

  fileLinksOf(row: any): any[] {
    return this.libraryById.get(row['#']?.n)?.link || [];
  }

  // Extension from the stored path, else from the file name (uploads are often
  // stored under a path with no extension)
  fileExt(file: any): string {
    const extOf = (value: string) => {
      const name = (value || '').split(/[?#]/)[0].split('/').pop() || '';
      return name.includes('.') ? name.split('.').pop()!.toLowerCase() : '';
    };
    return extOf(file?.link) || extOf(file?.name);
  }

  // Same as the edit dialog's file list: server paths get the static prefix
  fileHref(file: any): string {
    const path = file?.link || '';
    return /^(https?:)?\/\//i.test(path) ? path : this.staticURL + path;
  }

  fileIcon(file: any): string {
    return this.getFileIcon('file.' + this.fileExt(file));
  }

  // Edit / Delete for the row's ⋮ menu, limited to what the user may do
  rowMenuItems(row: any): MenuItem[] {
    return (row['Action'] || [])
      .filter((action: any) => this.canRunAction(action.n))
      .map((action: any) => ({
        label: this.translate(action.n == 'Update' ? 'Edit' : action.n),
        icon: action.i,
        styleClass: action.n == 'Delete' ? 'kl-menu-danger' : '',
        command: () => this.actionCall({ action: action.n, id: row['#'].n }),
      }));
  }

  openRowMenu(event: Event, row: any) {
    this.activeRowMenu = this.rowMenuItems(row);
    this.rowMenu.toggle(event);
  }

  // PrimeNG 15's OverlayPanel.toggle() breaks when it moves between targets: it
  // reopens with show(null, target), which throws on null.stopPropagation() and
  // leaves the panel stuck until reload. So close first, then open on the new
  // badge once the close has finished (see onFilesPanelHide).
  private pendingFilesPanel: { target: EventTarget; row: any } | null = null;
  private filesPanelTarget: EventTarget | null = null;

  openFilesPanel(event: Event, row: any) {
    const target = event.currentTarget as EventTarget;
    if (!this.filesPanel.overlayVisible) {
      this.showFilesPanel(target, row);
    } else if (this.filesPanelTarget === target) {
      this.filesPanel.hide();
    } else {
      this.pendingFilesPanel = { target, row };
      this.filesPanel.hide();
    }
  }

  onFilesPanelHide() {
    this.filesPanelTarget = null;
    const pending = this.pendingFilesPanel;
    this.pendingFilesPanel = null;
    if (pending) {
      // onHide fires just before PrimeNG clears its animation flag
      setTimeout(() => this.showFilesPanel(pending.target, pending.row));
    }
  }

  private showFilesPanel(target: EventTarget, row: any) {
    this.activeFiles = this.fileLinksOf(row);
    this.activeFilesTitle = row['العنوان']?.n;
    this.filesPanelTarget = target;
    this.filesPanel.show({ stopPropagation: () => {}, currentTarget: target } as any, target);
  }

  async downloadFiles(row: any) {
    const id = row['#'].n;
    const files = this.fileLinksOf(row);
    if (this.rowDownloads.has(id) || files.length == 0) return;

    const progress = { done: 0, total: files.length };
    this.rowDownloads.set(id, progress);
    const results = await Promise.all(
      files.map(async (file) => {
        const ok = await this.fetchAndSave(file);
        progress.done++;
        return ok;
      })
    );
    this.rowDownloads.delete(id);
    this.reportFailedDownloads(results);
  }

  async downloadFile(file: any) {
    if (this.fileDownloads.has(file)) return;
    this.fileDownloads.add(file);
    const ok = await this.fetchAndSave(file);
    this.fileDownloads.delete(file);
    this.reportFailedDownloads([ok]);
  }

  // Same blob download as the public library page; resolves false on failure
  private async fetchAndSave(file: any): Promise<boolean> {
    try {
      const blob = await firstValueFrom(this.http.get(this.staticURL + file.link, { responseType: 'blob' }));
      const anchor = document.createElement('a');
      anchor.href = URL.createObjectURL(blob);
      anchor.download = file.name;
      anchor.click();
      setTimeout(() => URL.revokeObjectURL(anchor.href));
      return true;
    } catch {
      return false;
    }
  }

  private reportFailedDownloads(results: boolean[]) {
    const failed = results.filter((ok) => !ok).length;
    if (failed == 0) return;
    this.messages = [
      {
        severity: 'error',
        summary: this.translate('error'),
        detail: `${this.translate('KL files failed to download')} (${failed}/${results.length})`,
      },
    ];
  }

  canRunAction(action: string): boolean {
    if (action == 'Delete') return this.hasPermission('d');
    if (action == 'Update') return this.hasPermission('u');
    return true;
  }

  applySearch(event: any) {
    this.searchterm = event;
    //Other search logic goes here
  }

  applyCategorySearch(event: any) {
    this.category = event;
    //Other search logic goes here
  }

  applyOUSearch(event: any) {
    this.selectedOU = event;
    //Other search logic goes here
  }

  applyFromDateFilter(event: any) {
    this.fromDate = event;
    //Other search logic goes here
  }

  applyToDateFilter(event: any) {
    this.toDate = event;
    //Other search logic goes here
  }

  getData = async () => {
    this.data = [];
    try {
      const res = await this.dataService.getData('knowledge-library');
      this.libraryData = res.data.filter((e: any) => {
        if (e.ou == null) {
          return this.parentOUS.includes(this.ous[0].label);
        } else {

          let allowed = this.ouService.childrenContainsId(this.ous, e.ou._id)
          if (allowed) {
            let available = this.availableOus.find(a => a._id == e.ou._id)
            if (!available) {
              this.availableOus.push(e.ou);
            }
            this.availableCategories.push({ label: e.categoryname, icon: e.categoryicon })
          }
          return allowed
        }
      });
      this.libraryById = new Map(this.libraryData.map((e: any) => [e._id, e]));
      this.mapToTableData(this.data, this.libraryData).then(() => {
        this.currentPage = Math.min(this.currentPage, this.totalPages);
      });
    } catch (error) {
      console.log(error);
    }
  };


  async deleteUpdatePermission(flag: string, id: string): Promise<boolean> {
    let ouChildren = await this.permissionService.extractOUChildrenFromData('KNOWLEDGE_LIBRARY', flag, this.ous);
    return this.ouService.childrenContainsId(ouChildren, id)
  }



  async mapToTableData(list: any[], dataToMap: any[]) {
    for (let e of dataToMap) {
      let obj: any = {
        '#': { n: e._id },
        العنوان: { n: e.name },
        'اسم الملف': { n: e.link.map((l: any) => l.name).join('\n') },
        الصورة: {
          i: e.image,
        },
        التاريخ: {
          n: new Date(e.createdAt).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          }),
          i: 'pi pi-calendar',
        },
        التصنيف: { n: e.categoryname, i: e.categoryicon },
        'وحدة تنظيمية ': {
          n: e.ou != null ? e.ou.name : 'الجهات المشاركة',
        },
        'تم الرفع بواسطة': { n: this.getUserDisplayName(e.createdBy) },
        'تاريخ التحديث': {
          n: e.updatedAt
            ? new Date(e.updatedAt).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
              })
            : '—',
          i: 'pi pi-calendar',
        },
        Action: []
      };
      let updatePermission = e.ou == null ? true : await this.deleteUpdatePermission('u', e.ou._id);
      if (updatePermission) {
        obj.Action.push(
          {
            n: 'Update',
            i: 'pi pi-file-edit',
            s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
          })
      }
      let deletePermission = e.ou == null ? true : await this.deleteUpdatePermission('d', e.ou._id);
      if (deletePermission) {
        obj.Action.push(
          {
            n: 'Delete',
            i: 'pi pi-times',
            s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
          })
      }
      list.push(obj);
    }
  }

  getCategories = async () => {
    try {
      let res = await this.dataService.getData('knowledge-library-category');
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.categoryData = res.data.map((e: any) => {
        return {
          label: e.name,
          icon: e.icon,
          value: e._id,
        };
      });
    } catch (error) {
      console.log(error);
    }
  };

  private getUserDisplayName(user: any): string {
    if (!user) return '—';
    const n = user.name;
    if (n && typeof n === 'object') {
      const composed = [n.first, n.middle, n.last].filter(Boolean).join(' ').trim();
      if (composed) return composed;
    } else if (typeof n === 'string' && n.trim()) {
      return n.trim();
    }
    return user.email || '—';
  }

  getFileIcon(link: any): string {
    const filename = link.split('/')[link.split('/').length - 1];

    const fileext = filename
      .split('.')
    [filename.split('.').length - 1].toLowerCase();

    switch (fileext) {
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
      case 'psd':
      case 'eps':
      case 'svg':
      case 'ai':
        return 'pi pi-image';

      case 'mp4':
      case 'mov':
      case 'wmv':
      case 'avi':
      case 'avchd':
      case 'mkv':
      case 'webm':
      case 'flv':
        return 'pi pi-video';

      case 'm4a':
      case 'flac':
      case 'mp3':
      case 'wav':
      case 'wma':
      case 'aac':
        return 'pi pi-volume-up';

      case 'zip':
      case 'rar':
        return 'pi pi-briefcase';

      case 'pptx':
      case 'pptm':
      case 'ppt':
        return 'pi pi-file';

      case 'xlsx':
      case 'xlsm':
      case 'csv':
        return 'pi pi-file-excel';

      case 'docx':
      case 'dot':
      case 'dotm':
      case 'txt':
      case 'odt':
        return 'pi pi-file-word';

      case 'pdf':
        return 'pi pi-file-pdf';

      default:
        return 'pi pi-file';
    }
  }
}

export interface Employee {
  _id: string;
  name: string;
  link: any[];
  image: string;
  downloadcount: string;
  description: string;
  createdAt: string;
  categoryname: string;
  categoryicon: string;
  entity?: string;
}

export interface EmpFilter {
  name: string;
  options: string[];
  defaultValue: string;
}

export interface enitiy {
  name: string;
  object: string;
  picture_sq: string;
}
